import { type, string, optional, array, number } from 'superstruct';
export const GiftBoxDescription = type({
    id: number(),
    description: optional(string())
});
export const CartDrawerIO = type({
    moneyFormat: string(),
    finalsales_infocart: optional(string()),
    giftBoxesTooltipTitle: optional(string()),
    giftBoxesDescriptions: optional(array(GiftBoxDescription))
});
